import useAxiosMutation from 'hooks/useAxiosMutation';
import { useQueryClient } from 'react-query';
import { BLUEPRINTS_BASE_KEY } from 'services/queryKeys';

export const useDeleteBlueprint = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isError, error } = useAxiosMutation<void>({
    onSuccess: () => {
      queryClient.invalidateQueries(BLUEPRINTS_BASE_KEY);
    },
  });

  const deleteBlueprint = async (blueprintId: number) => {
    const result = await mutateAsync({
      method: 'DELETE',
      path: `/blueprints/${blueprintId}`,
    });

    return result;
  };

  return {
    deleteBlueprint,
    isLoading,
    isError,
    error,
  };
};
